export default __webpack_public_path__ + "static/media/Qualcomm.32b66549.jpg";